import { CoverTimeTone } from './covers-format.utils'

export const CoversTab = {
  Requests: 'requests',
  Open: 'open',
  Mine: 'mine',
} as const
export type CoversTab = (typeof CoversTab)[keyof typeof CoversTab]

export const MANAGER_COVERS_TABS: readonly CoversTab[] = [
  CoversTab.Requests,
  CoversTab.Open,
  CoversTab.Mine,
]

export const STAFF_COVERS_TABS: readonly CoversTab[] = [CoversTab.Open, CoversTab.Mine]

export const COVERS_TAB_LABEL_KEYS: Record<CoversTab, string> = {
  [CoversTab.Requests]: 'core:covers.page.tabs.requests',
  [CoversTab.Open]: 'core:covers.page.tabs.open',
  [CoversTab.Mine]: 'core:covers.page.tabs.mine',
}

export const CoverPermission = {
  Request: 'schedule__covers__request',
  Claim: 'schedule__covers__claim',
  Approve: 'schedule__covers__approve',
  ManageQualifications: 'schedule__covers__manage_qualifications',
  Settings: 'settings__covers',
} as const

export const COVER_BOARD_PERMISSIONS = [
  CoverPermission.Request,
  CoverPermission.Claim,
  CoverPermission.Approve,
]

export const OPEN_COVERS_LIMIT = 200
export const MY_COVERS_LIMIT = 100

export const CoverCardVariant = {
  Default: 'default',
  Urgent: 'urgent',
  Covered: 'covered',
  Muted: 'muted',
} as const
export type CoverCardVariant = (typeof CoverCardVariant)[keyof typeof CoverCardVariant]

export const CoverTone = {
  Primary: 'primary',
  Warning: 'warning',
  Success: 'success',
  Error: 'error',
  Info: 'info',
  Neutral: 'neutral',
} as const
export type CoverTone = (typeof CoverTone)[keyof typeof CoverTone]

export type CoverToneColors = { bgcolor: string; color: string }

export const COVER_TONE_COLORS: Record<CoverTone, CoverToneColors> = {
  [CoverTone.Primary]: { bgcolor: 'primary.lightest', color: 'primary.main' },
  [CoverTone.Warning]: { bgcolor: 'warning.lightest', color: 'warning.dark' },
  [CoverTone.Success]: { bgcolor: 'success.lightest', color: 'success.dark' },
  [CoverTone.Error]: { bgcolor: 'error.lightest', color: 'error.dark' },
  [CoverTone.Info]: { bgcolor: 'blue.lightest', color: 'blue.dark' },
  [CoverTone.Neutral]: { bgcolor: 'gray.8', color: 'gray.64' },
}

export const COVER_VARIANT_TONES: Record<CoverCardVariant, CoverTone> = {
  [CoverCardVariant.Default]: CoverTone.Primary,
  [CoverCardVariant.Urgent]: CoverTone.Warning,
  [CoverCardVariant.Covered]: CoverTone.Success,
  [CoverCardVariant.Muted]: CoverTone.Neutral,
}

export const COVER_TIME_TONES: Record<CoverTimeTone, CoverTone> = {
  [CoverTimeTone.Urgent]: CoverTone.Warning,
  [CoverTimeTone.Soon]: CoverTone.Primary,
  [CoverTimeTone.Later]: CoverTone.Neutral,
}
